import $ from "jquery";

const FaqAccordion = () => {
	const init = () => {
		fold();
	};

	const el = {
		button: ".js-FaqAccordion__Button",
		desc: ".js-FaqAccordion__Desc",
	};

	const fold = () => {
		if ($(el.button).length === 0) return;

		$(document).on("click", el.button, function () {
			if ($(this).parent().hasClass("active")) {
				$(this).parent().removeClass("active");
				$(this).next(el.desc).slideUp();
			} else {
				$(el.button).parent().removeClass("active");
				$(el.button).next(el.desc).slideUp();

				$(this).parent().addClass("active");
				$(this).next(el.desc).slideDown();
			}
		});
	};

	init();
};

export default FaqAccordion;
